/* External dependencies */
import { gql } from '@apollo/client';

export const updateWarehouseMutation = gql`
  mutation updateWarehouse($input: UpdateWarehouseInput!) {
    updateWarehouse(input: $input) {
      id
      city
      country
      createdDate
      address
      phone
      postcode
      region
      status
      updatedDate
    }
  }
`;
